import { createReducer } from "redux-starter-kit";
import {
  startLoadArticlesAction,
  endLoadArticlesAction,
  articlesFailLoadAction,
  modifyOneTocDataAction,
  recoverLastMoveAction,
  snapShotTocStateAction,
  deleteTocArticleAction,
  appendTocArticleAction,
  apiSetTocArticleTitleAction,
  apiSetTocArticleReadyAction,
  createManualArticleAction,
  mergeArticleAction,
  setSaveLoadingAction,
  setLockingIDAction,
  mergeToLockArticleAction,
  changeTocModeAction,
  enterIssueDescriptionAction
} from "../actions/tocEditPanel";

const INIT_STATE = {
  loadedIssueID: null,

  editHistory: [
    /* { articleIDs: [], articlesDict: {} }, ... */
  ],
  errMsg: null,
  lastAppendTime: null,
  isSaveLoading: false,
  lockingID: null,
  saveTemp: true,
  mode: "toc",
  description: ""
};

const RECOVER_STEP_LIMIT = 6;

const tocEditPanel = createReducer(INIT_STATE, {
  [startLoadArticlesAction]: (state, action) => {
    state.loadedIssueID = null;
    state.editHistory = [];
    state.errMsg = null;
  },
  [changeTocModeAction]: (state, action) => {
    state.lockingID = null;
    state.mode = action.payload.mode;
  },
  [enterIssueDescriptionAction]: (state, action) => {
    state.description = action.payload.description;
  },
  [endLoadArticlesAction]: (state, action) => {
    state.loadedIssueID = action.payload.issueID;
    const articleIDs = action.payload.articles.map(article => article.id);
    let articlesDict = {};

    state.saveTemp = action.payload.saveTemp;

    for (let i = 0; i < action.payload.articles.length; i++) {
      const article = action.payload.articles[i];

      let textLineIDs = null;
      let orderedTextLineIDs = null;
      try {
        textLineIDs = article.title_component.textLineIDs;
      } catch (e) {
        textLineIDs = article.textLineIDs;
      }
      try {
        orderedTextLineIDs = article.title_component.orderedTextLineIDs;
      } catch (e) {
        orderedTextLineIDs = article.orderedTextLineIDs;
      }

      articlesDict[article.id] = {
        id: article.id,
        first_page: article.first_page,
        last_page: article.last_page,
        title: article.title,
        isTextServerProcessed: true,
        textLineIDs: textLineIDs,
        orderedTextLineIDs: orderedTextLineIDs
      };
    }

    state.errMsg = null;
    state.editHistory = [{ articleIDs, articlesDict }];
  },
  [articlesFailLoadAction]: (state, action) => {
    state.loadedIssueID = action.payload.issueID;
    state.errMsg = action.payload.errMsg;
    state.editHistory = [];
  },
  [snapShotTocStateAction]: (state, action) => {
    const { articleIDs, articlesDict } = state.editHistory[
      state.editHistory.length - 1
    ];

    const newHistory = {
      articleIDs: [...articleIDs],
      articlesDict: { ...articlesDict }
    };

    state.editHistory.push(newHistory);

    if (state.editHistory.length > RECOVER_STEP_LIMIT) {
      state.editHistory.shift();
    }
  },
  [modifyOneTocDataAction]: (state, action) => {
    const { articlesDict } = state.editHistory[state.editHistory.length - 1];
    const article = articlesDict[action.payload.id];

    if (article != null) {
      if (article.isTextServerProcessed && action.payload.title != null) {
        article.title = action.payload.title;
      }

      if (action.payload.first_page != null) {
        article.first_page = action.payload.first_page;
      }

      if (action.payload.last_page != null) {
        article.last_page = action.payload.last_page;
      }
    }
  },
  [recoverLastMoveAction]: (state, action) => {
    if (state.editHistory.length > 1) {
      state.editHistory.pop();
    }
  },
  [deleteTocArticleAction]: (state, action) => {
    const { articleIDs, articlesDict } = state.editHistory[
      state.editHistory.length - 1
    ];

    const idToBeDeleted = action.payload.id;
    let newDict = { ...articlesDict };

    delete newDict[idToBeDeleted];

    const newHistory = {
      articleIDs: articleIDs.filter(
        anArticleID => anArticleID !== idToBeDeleted
      ),
      articlesDict: newDict
    };

    state.editHistory.push(newHistory);

    if (state.editHistory.length > RECOVER_STEP_LIMIT) {
      state.editHistory.shift();
    }

    if (idToBeDeleted === state.lockingID) {
      state.lockingID = null;
    }
  },
  [createManualArticleAction]: (state, action) => {
    const newID = action.payload.newID;
    let insertIndex = action.payload.insertIndex;

    const { articleIDs, articlesDict } = state.editHistory[
      state.editHistory.length - 1
    ];

    insertIndex = insertIndex < 0 ? 0 : insertIndex;
    insertIndex =
      insertIndex > articleIDs.length ? articleIDs.length : insertIndex;

    let newDict = { ...articlesDict };
    let newArr = [...articleIDs];

    newArr.splice(insertIndex, 0, newID);

    let newFirstPage = 1;

    if (insertIndex - 1 >= 0) {
      const lastEndPageStr =
        articlesDict[articleIDs[insertIndex - 1]].last_page;
      let lastEndPage = parseInt(lastEndPageStr);

      if (isNaN(lastEndPage)) {
        newFirstPage = lastEndPageStr;
      } else {
        newFirstPage = lastEndPage + 1;
      }
    }

    if (
      action.payload.maxPage != null &&
      !isNaN(action.payload.maxPage) &&
      !isNaN(newFirstPage)
    ) {
      if (newFirstPage > action.payload.maxPage) {
        newFirstPage = action.payload.maxPage;
      }
    }

    newDict[newID] = {
      id: newID,
      first_page: newFirstPage,
      last_page: newFirstPage,
      title: action.payload.title == null ? "" : action.payload.title,
      isTextServerProcessed: true,
      textLineIDs: null
    };

    const newHistory = {
      articleIDs: newArr,
      articlesDict: newDict
    };

    state.editHistory.push(newHistory);

    if (state.editHistory.length > RECOVER_STEP_LIMIT) {
      state.editHistory.shift();
    }
  },
  [appendTocArticleAction]: (state, action) => {
    const { articleIDs, articlesDict } = state.editHistory[
      state.editHistory.length - 1
    ];

    const page = action.payload.page;
    const newID = action.payload.newID;
    const timeStamp = action.payload.timeStamp;

    const newTocArticle = {
      id: newID,
      first_page: page + 1,
      last_page: page + 1,
      title: "",
      isTextServerProcessed: false,
      textLineIDs: action.payload.textLineIDs
    };

    let newDict = { ...articlesDict };
    newDict[newID] = newTocArticle;

    if (articleIDs.length > 0) {
      if (page > newDict[articleIDs[articleIDs.length - 1]].first_page) {
        newDict[articleIDs[articleIDs.length - 1]] = {
          ...newDict[articleIDs[articleIDs.length - 1]],
          last_page: page
        };
      }
    }

    const newHistory = {
      articleIDs: [...articleIDs, newID],
      articlesDict: newDict
    };

    state.editHistory.push(newHistory);

    if (state.editHistory.length > RECOVER_STEP_LIMIT) {
      state.editHistory.shift();
    }

    state.lastAppendTime = timeStamp;
  },
  [apiSetTocArticleReadyAction]: (state, action) => {
    const { articlesDict } = state.editHistory[state.editHistory.length - 1];

    const article = articlesDict[action.payload.id];

    if (article == null) {
      return;
    }

    article.isTextServerProcessed = action.payload.ready;
  },
  [apiSetTocArticleTitleAction]: (state, action) => {
    const { articlesDict } = state.editHistory[state.editHistory.length - 1];

    const article = articlesDict[action.payload.id];

    if (article == null) {
      return;
    }

    article.title = action.payload.title;
    article.isTextServerProcessed = action.payload.ready;

    if (action.payload.orderedTextLineIDs != null) {
      article.orderedTextLineIDs = action.payload.orderedTextLineIDs;
    }
  },
  [mergeArticleAction]: (state, action) => {
    const { articleIDs, articlesDict } = state.editHistory[
      state.editHistory.length - 1
    ];

    const fromID = action.payload.fromID;
    const toID = action.payload.toID;
    const newTextLineIDs = action.payload.newTextLineIDs;
    const newOrderedTextLineIDs = action.payload.newOrderedTextLineIDs;

    const fromArticle = articlesDict[fromID];
    const toArticle = articlesDict[toID];

    if (fromArticle == null || toArticle == null) {
      return;
    }

    const newToArticle = {
      ...toArticle,
      title: toArticle.title + fromArticle.title,
      isTextServerProcessed:
        fromArticle.textLineIDs == null || toArticle.textLineIDs == null,
      textLineIDs: newTextLineIDs,
      orderedTextLineIDs: newOrderedTextLineIDs
    };

    let newDict = { ...articlesDict };
    newDict[toID] = newToArticle;
    delete newDict[fromID];

    if (fromID === state.lockingID) {
      state.lockingID = null;
    }

    let newArticleIDS = [...articleIDs].filter(id => id !== fromID);

    const newHistory = {
      articleIDs: newArticleIDS,
      articlesDict: newDict
    };

    state.editHistory.push(newHistory);

    if (state.editHistory.length > RECOVER_STEP_LIMIT) {
      state.editHistory.shift();
    }
  },
  [mergeToLockArticleAction]: (state, action) => {
    const { articleIDs, articlesDict } = state.editHistory[
      state.editHistory.length - 1
    ];

    const toID = action.payload.toID;
    const toArticle = articlesDict[toID];

    if (toArticle == null) {
      state.lockingID = null;
      return;
    }

    const toTextLineIDs = toArticle.textLineIDs;
    const addingTextLineIDs = action.payload.textLineIDs;
    const toOrderedTextLineIDs = toArticle.orderedTextLineIDs;

    const newTextLineIDs = combineTextLineIDs(
      action.payload.textLineIDs,
      toArticle
    );

    const newToArticle = {
      ...toArticle,
      isTextServerProcessed: false,
      textLineIDs: newTextLineIDs
    };

    if (action.payload.ordered === true) {
      if (toOrderedTextLineIDs == null || toOrderedTextLineIDs.length <= 0) {
        let newOrderedTextLineIDs = [];

        if (toTextLineIDs != null) {
          newOrderedTextLineIDs.push(toTextLineIDs);
        }

        if (addingTextLineIDs != null) {
          newOrderedTextLineIDs.push(addingTextLineIDs);
        }

        newToArticle.orderedTextLineIDs = newOrderedTextLineIDs;
      } else {
        if (addingTextLineIDs != null) {
          let newOrderedTextLineIDs = [...toOrderedTextLineIDs];
          newOrderedTextLineIDs.push(addingTextLineIDs);

          newToArticle.orderedTextLineIDs = newOrderedTextLineIDs;
        }
      }
    }

    let newDict = { ...articlesDict };
    newDict[toID] = newToArticle;

    const newHistory = {
      articleIDs: articleIDs,
      articlesDict: newDict
    };

    state.editHistory.push(newHistory);

    if (state.editHistory.length > RECOVER_STEP_LIMIT) {
      state.editHistory.shift();
    }
  },
  [setSaveLoadingAction]: (state, action) => {
    state.isSaveLoading = action.payload.isSaveLoading;
  },
  [setLockingIDAction]: (state, action) => {
    state.lockingID = action.payload.lockingID;
  }
});

function combineTextLineIDs(inputTextLineIDs, toArticle) {
  let combinedTextLineIDs = null;

  if (inputTextLineIDs != null && toArticle.textLineIDs != null) {
    combinedTextLineIDs = {};

    const fromPageIDArr = Object.keys(inputTextLineIDs);
    const toPageIDArr = Object.keys(toArticle.textLineIDs);

    const newPageIDArr = Array.from(new Set(fromPageIDArr.concat(toPageIDArr)));

    let i;
    for (i = 0; i < newPageIDArr.length; i++) {
      const pageID = newPageIDArr[i];

      const fromTextPageData = inputTextLineIDs[pageID];
      const toTextPageData = toArticle.textLineIDs[pageID];

      const fromTextLineIndexes =
        fromTextPageData == null ? null : fromTextPageData.textLineIndexes;
      const toTextLineIndexes =
        toTextPageData == null ? null : toTextPageData.textLineIndexes;

      let combinedLineIndexes = null;

      if (fromTextLineIndexes != null && toTextLineIndexes != null) {
        combinedLineIndexes = Array.from(
          new Set(fromTextLineIndexes.concat(toTextLineIndexes))
        ).sort();
      } else if (fromTextLineIndexes != null) {
        combinedLineIndexes = fromTextLineIndexes;
      } else if (toTextLineIndexes != null) {
        combinedLineIndexes = toTextLineIndexes;
      }

      const data = {
        pageID: pageID,
        textLineIndexes: combinedLineIndexes
      };

      combinedTextLineIDs[pageID] = data;
    }
  } else if (inputTextLineIDs != null) {
    combinedTextLineIDs = inputTextLineIDs;
  } else if (toArticle.textLineIDs != null) {
    combinedTextLineIDs = toArticle.textLineIDs;
  }

  return combinedTextLineIDs;
}

export default tocEditPanel;
